import React, {Fragment, useState, useEffect, useCallback} from 'react';
import PropTypes from 'prop-types';
import {connect, useSelector, useDispatch} from 'react-redux';
import {getProductions} from "../../actions/production";
import ProductionUpdateForm from "./ProductionUpdateForm";
import SearchForm from "../layout/SearchForm";
import CustomPaginationWithManyPages from "../layout/CustomPaginationWithManyPages";
import TableSpinner from "../layout/TableSpinner";
import ProductionItem from "./ProductionItem";
import FilterByDateRange from "../layout/FilterByDateRange";
import ProductionDeleteForm from "./ProductionDeleteForm";
import useActiveFirm from '../../hooks/useActiveFirm';

const Productions = () => {
    const dispatch = useDispatch();
    const {productions, loading, numberOfPages, currentPage, total_productions} = useSelector(state => state.production);
    const { firmId, firmName } = useActiveFirm();

    const [updateFormShown, setUpdateFormShown] = useState(false);

    // Wrapper function to ensure firm_id is always included when calling getProductions
    // Returns a thunk function (async action) that can be dispatched
    const getProductionsWithFirm = useCallback((page, params = {}) => {
        const filters = { ...params };
        if (firmId) {
            filters.firm_id = firmId;
        }
        // Clean up undefined/null values
        Object.keys(filters).forEach(key => {
            if (filters[key] === undefined || filters[key] === null || filters[key] === '' || filters[key] === 'undefined' || filters[key] === 'null') {
                delete filters[key];
            }
        });
        // Return the thunk function, don't dispatch it
        return getProductions(page, filters);
    }, [firmId]);

    // Fetch productions when firm changes
    useEffect(() => {
        if (firmId) {
            dispatch(getProductionsWithFirm(1, {}));
        }
    }, [dispatch, firmId, getProductionsWithFirm]);

    return (
        <Fragment>
            <div className="container-fluid p-0">

                <div className="row mt-4">
                    <div className="col-md-12 col-lg-8">
                        <h3 className="h4 mb-1">
                            <strong>Mahsulot ishlab chiqarishlar</strong> ({total_productions})
                            {firmName && <span className="text-muted ms-2" style={{fontSize: '14px', fontWeight: 'normal'}}>— {firmName}</span>}
                        </h3>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-6">
                        <SearchForm getPageItems={getProductionsWithFirm}/>
                    </div>

                    <div className="col-6">
                        <FilterByDateRange getPageItems={getProductionsWithFirm}/>
                    </div>

                    {/*<div className="col-md-3">*/}
                    {/*    <div className="crud_actions text-end">*/}
                    {/*        {*/}
                    {/*            role_name === 'superadmin' || role_name === 'director' || role_name === 'manager' || role_name === 'storekeeper' ? (*/}
                    {/*                <button className="btn btn-primary" onClick={() => setCreateFormShown(true)}>*/}
                    {/*                    Mahsulot*/}
                    {/*                    <Plus/>*/}
                    {/*                </button>*/}
                    {/*            ) : ''*/}
                    {/*        }*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>

                <div className="row mt-2 position-relative">
                    <div className="col-xl-12 col-xxl-12 d-flex">

                        <div className="card w-100 table-responsive">
                            {loading && <TableSpinner/>}
                            <table className="table custom-table table-hover">
                                <thead className="table-light">
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Mahsulot</th>
                                    <th scope="col">Firm</th>
                                    <th scope="col">Sklad nomi</th>
                                    <th scope="col">Soni</th>
                                    <th scope="col">O'lchov</th>
                                    <th scope="col">Tan narxi</th>
                                    <th scope="col">Sana</th>
                                    <th scope="col">Yaratilgan</th>
                                    <th scope="col">Amallar</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    productions.map((item, index) => (
                                        <ProductionItem key={index} index={index} production={item}
                                                     handleShow={() => setUpdateFormShown(true)}
                                                     handleClose={() => setUpdateFormShown(false)}
                                        />
                                    ))
                                }

                                </tbody>
                            </table>

                        </div>

                    </div>

                </div>


                <div className="row">
                    <div className="col-xl-12 col-xxl-12 d-flex">
                        <CustomPaginationWithManyPages
                            numberOfPages={numberOfPages}
                            getPageItems={getProductionsWithFirm}
                            current_page={currentPage}
                        />
                    </div>
                </div>

            </div>


            {
                updateFormShown ? (
                    <ProductionUpdateForm show={updateFormShown}
                                       handleShow={() => setUpdateFormShown(true)}
                                       handleClose={() => setUpdateFormShown(false)}
                    />
                ) : ''
            }

            <ProductionDeleteForm/>


        </Fragment>
    );
};


Productions.propTypes = {
    getProductions: PropTypes.func.isRequired,
    production: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    production: state.production,
});

export default connect(mapStateToProps, {getProductions})(Productions);
